module.exports = __webpack_public_path__ + "img/l1.382aa777.png";